import { Modal } from 'antd'
import React from 'react'

type CalendarModalProps = {
  isOpen: boolean
  handleConfirm: ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
  handleCancel: ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
  children: React.ReactNode
  footer?: React.ReactNode | ((originNode: React.ReactNode, extra: {
    OkBtn: React.FC<{}>;
    CancelBtn: React.FC<{}>;
  }) => React.ReactNode)
}

export default function CalendarModal({isOpen, handleConfirm, handleCancel, children, footer = null }: CalendarModalProps) {
  return (
    <Modal
        closeIcon={null}
        open={isOpen}
        onOk={handleConfirm}
        onCancel={handleCancel}
        footer={footer}
        zIndex={10000}
        destroyOnHidden
      >
        {children}
      </Modal>
  )
}
